<template>
	<div class="form">
		<h4 class="step-title">What is your current license status?</h4>
		<div
			class="step-content d-flex flex-column align-items-center step-button-list wider"
		>
			<scrollable-button-list
				v-bind:items="licenseStatuses"
				v-bind:onclick="complete"
				v-bind:value="lead.autoInsurance.licenseStatus"
			/>
		</div>
	</div>
</template>

<script>
import ScrollableButtonList from "../shared/ScrollableButtonList.vue";

export default {
	name: "LicenseStatus",
	components: {
		ScrollableButtonList,
	},
	data: function () {
		return {
			licenseStatuses: [
				{ text: "Valid", value: "Valid" },
				{ text: "Permit", value: "Permit" },
				{ text: "Expired", value: "Expired" },
				{ text: "Suspended", value: "Suspended" },
				{ text: "Revoked", value: "Revoked" },
				{ text: "None", value: "None" },
			],
		};
	},
	props: {
		lead: Object,
	},
	methods: {
		complete: function (value) {
			this.lead.autoInsurance.licenseStatus = value;
			this.$emit("complete", this.$options.name, value);
		},
	},
};
</script>
